import { Injectable } from '@angular/core';

export type PointerSession = Readonly<{
  startX: number;
  startY: number;
  startedAt: number;
}>;

export type PointerTapResult = Readonly<{
  isTap: boolean;
  isLeftZone: boolean;
}>;

@Injectable({ providedIn: 'root' })
export class CarouselPointerService {
  private readonly tapMaxDurationMs = 220;
  private readonly tapMaxMovementPx = 30;

  start(event: PointerEvent): PointerSession | null {
    if (!event.isPrimary) {
      return null;
    }
    return {
      startX: event.clientX,
      startY: event.clientY,
      startedAt: performance.now(),
    };
  }

  resolveTap(
    event: PointerEvent,
    session: PointerSession | null,
    host: HTMLElement | null,
  ): PointerTapResult {
    if (!session || !host || !event.isPrimary) {
      return { isTap: false, isLeftZone: false };
    }
    const elapsedMs = performance.now() - session.startedAt;
    const deltaX = event.clientX - session.startX;
    const deltaY = event.clientY - session.startY;
    const isTap =
      elapsedMs <= this.tapMaxDurationMs &&
      Math.abs(deltaX) <= this.tapMaxMovementPx &&
      Math.abs(deltaY) <= this.tapMaxMovementPx;
    if (!isTap) {
      return { isTap: false, isLeftZone: false };
    }
    const rect = host.getBoundingClientRect();
    if (rect.width <= 0) {
      return { isTap: false, isLeftZone: false };
    }
    const relativeX = event.clientX - rect.left;
    return {
      isTap: true,
      isLeftZone: relativeX < rect.width / 2,
    };
  }
}
